import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  withStyles,
  IconButton,
  Icon,
  ListItemIcon,
  ListSubheader,
  CircularProgress,
  Menu,
  MenuItem,
  Divider,
} from '@material-ui/core';
import {
  CheckCircle,
  Update,
} from '@material-ui/icons';

import { patchEvent } from '@pingum/app-state-management/event/actions';

import styles from './styles';

export class EventActionsComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      open: false,
      element: null,
    };
  }

  handleOpen = (e) => {
    this.setState({
      open: true,
      element: e.currentTarget,
    });
    e.stopPropagation();
  }

  handleClose = (e) => {
    this.setState({
      open: false,
      element: null,
    });
    e.stopPropagation();
  }

  handleUpdateEvent = (request, e) => {
    this.props.patchEvent(this.props.event.id, request);
    this.handleClose(e);
  }

  render() {
    const {
      event,
      isUpdatingEvent,
      openEventDetailsPage,
      openHistoryDialog,
    } = this.props;
    const {
      element,
      open,
    } = this.state;

    return (
      <div>
        {
          isUpdatingEvent
            ? <CircularProgress size={30} />
            : (
              <IconButton
                onClick={this.handleOpen}
                id="menu-btn"
                aria-owns={open
                  ? 'menu-appbar'
                  : null}
                aria-haspopup="true"
              >
                <Icon>more_vert</Icon>
              </IconButton>
            )
        }
        <Menu
          id="menu-appbar"
          anchorEl={element}
          open={open}
          onClose={this.handleClose}
        >
          <ListSubheader>Actions</ListSubheader>

          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              this.handleClose(e);
              openEventDetailsPage();
            }}
          >
            <ListItemIcon>
              <Icon>edit</Icon>
            </ListItemIcon>
            Edit
          </MenuItem>

          <MenuItem
            onClick={(e) => {
              e.stopPropagation();
              this.handleClose(e);
              openHistoryDialog();
            }}
          >
            <ListItemIcon>
              <Icon>skip_next</Icon>
            </ListItemIcon>
            Change Status
          </MenuItem>

          <Divider />

          {
            event.completeDate
              ? (
                <MenuItem
                  onClick={(e) => {
                    this.handleUpdateEvent({ completeEvent: false }, e);
                  }}
                >
                  <ListItemIcon>
                    <Update />
                  </ListItemIcon>
                  Reactivate
                </MenuItem>
              )
              : (
                <MenuItem
                  onClick={(e) => {
                    this.handleUpdateEvent({ completeEvent: true }, e);
                  }}
                >
                  <ListItemIcon>
                    <CheckCircle />
                  </ListItemIcon>
                  Complete
                </MenuItem>
              )
          }
          {
            event.archived
              ? (
                <MenuItem
                  onClick={(e) => {
                    this.handleUpdateEvent({ archived: false }, e);
                  }}
                >
                  <ListItemIcon>
                    <Icon>restore_from_trash</Icon>
                  </ListItemIcon>
                  Restore
                </MenuItem>
              )
              : (
                <MenuItem
                  onClick={(e) => {
                    this.handleUpdateEvent({ archived: true }, e);
                  }}
                >
                  <ListItemIcon>
                    <Icon>delete</Icon>
                  </ListItemIcon>
                  Archive
                </MenuItem>
              )
          }
        </Menu>
      </div>
    );
  }
}

EventActionsComponent.propTypes = {
  event: PropTypes.object,
  isUpdatingEvent: PropTypes.bool,
  patchEvent: PropTypes.func,
  openEventDetailsPage: PropTypes.func,
  openHistoryDialog: PropTypes.func,
};

EventActionsComponent.defaultProps = {
  event: {},
  isUpdatingEvent: false,
  patchEvent: () => {},
  openEventDetailsPage: () => {},
  openHistoryDialog: () => {},
};

export const mapStateToProps = (state) => ({ isUpdatingEvent: state.event.isUpdatingEvent });

export const mapDispatchToProps = (dispatch) => ({ patchEvent: (id, request) => dispatch(patchEvent(id, request)) });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(EventActionsComponent));
